var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"map",staticClass:"map-wrapper pb-3"},[_c('div',{attrs:{"id":"map"}}),(_vm.init && _setup.initalized && _setup.store.state.region.map)?_c(_setup.MapTilerInner,{attrs:{"shop-wall":_vm.shopWall}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }